import { ModalsProvider } from '@mantine/modals';
import { Notifications } from '@mantine/notifications';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { PropsWithChildren } from 'react';
import { BrowserRouter } from 'react-router-dom';

import { ThemeProvider } from '@mygpt/app';

// remove end slash from basename // @ts-ignore
const basename = import.meta.env.VITE_PUBLIC_PATH === '/' ? '/' : import.meta.env.VITE_PUBLIC_PATH.replace(/\/$/, '');

// Create a client
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 1,
    },
  },
});

export default ({ children }: PropsWithChildren) => {
  return (
    <BrowserRouter basename={basename}>
      <QueryClientProvider client={queryClient}>
        <ThemeProvider>
          <Notifications position="top-center" limit={3} />
          <ModalsProvider>{children}</ModalsProvider>
        </ThemeProvider>
      </QueryClientProvider>
    </BrowserRouter>
  );
};
